//component entry file
import PortfolioAnalyst from "./components/portfolioAnalyst/PortfolioAnalyst.vue";

export default PortfolioAnalyst;